import { $, effect, type Properties, resolve, signal } from "signlets";

export type NumberInputProps = {
  number: number;
  min?: number;
  max?: number;
  step?: number;
  onChangeNumber: (_: number) => void;
};

export const NumberInput = ({
  number,
  min,
  max,
  step,
  onChangeNumber,
}: Properties<NumberInputProps>) => {
  const [element, setElement] = signal<HTMLInputElement | undefined>(undefined);
  const [focused, setFocused] = signal(false);

  effect(() => {
    if (focused()) return;
    const input = element();
    if (!input) return;
    const value = resolve(number).toString();
    if (input.value !== value) input.value = value;
  });

  const onInput = ({
    currentTarget,
  }: Event & { currentTarget: HTMLInputElement }) => {
    const { value } = currentTarget;
    const number = parseFloat(value);
    if (
      !isNaN(number) &&
      number >= (resolve(min) ?? -Infinity) &&
      number <= (resolve(max) ?? Infinity)
    )
      onChangeNumber(number);
  };

  const onBlur = () => setFocused(false);
  const onFocus = () => setFocused(true);

  return (
    <input
      ref={setElement}
      type="number"
      defaultValue={$(() => resolve(number).toString())}
      min={$(() => resolve(min)?.toString())}
      max={$(() => resolve(max)?.toString())}
      step={$(() => resolve(step)?.toString())}
      onInput={onInput}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};
